<section>
  <div>
    <form class="standard-form theory-of-action-form" [formGroup]="theoryOfActionForm">
      <div class="small-input-header">Select the Critical Initiative to be displayed below:</div>
      <div class="selection-container">
        <div class="input-error-wrap sans-margin">
          <div class="form-row">
            <div class="control-container">
              <app-priority-dropdown
                [singleSelection]="true"
                [showDates]="true"
                [availableOptions]="dropdownPriorityInitiatives"
                [styleClassAppends]="['default-selector-width']"
                (valueChangedCallback)="dropdownValueChanged($event)"
                defaultLabel="Select Critical Initiative(s)"
                selectedItemsLabel="Critical Initiatives Selected ({0})"
                selectAllItemsLabel="Select All Critical Initiatives"
                allItemsSelectedLabel="All Critical Initiatives Selected ({0})"
              ></app-priority-dropdown>

            </div>
          </div>
          <app-error-msg [control]="selectedInitiativeField"
                         [show]="selectedInitiativeField.invalid && selectedInitiativeField.touched && selectedInitiativeField.dirty">
          </app-error-msg>
        </div>
      </div>
    </form>
  </div>
  <div auto="toa-table" class="initiative-content">
    <!-- Mission -->
    <div auto="mission-section-header" class="section-header">
      <div class="section-vbar" [style.background-color]="vbarBaseColor">
      </div>
      <div class="section-header-content-wrapper top">
        <div class="section-header-text dark">
          <h4>Mission</h4>
        </div>
        <div class="section-content-text">
          <app-edit-overlay [isPlaceholder]="!hasSelectedInitiative || hasNoMission"
                            [isEditor]="!isEditItemDisabled"
                            class="allow-shrink min-40"
                            (planCoordinateChange)="onPlanCoordinateChangePurposeMissionBeliefs()">
            <p class="min-40" [innerHTML]="missionDescription"></p>
          </app-edit-overlay>
        </div>
      </div>
    </div>
    <div class="section-content">
      <div class="section-vbar" [style.background-color]="vbarDark40Color">
        <div class="section-vbar-diamond" [style.background-color]="vbarBaseColor"></div>
      </div>
      <div class="section-content-subheader">
        <h4>Resource(s)</h4>
        <div class="financial-resources" *ngIf="totalFinancialResources">
          <span class="semi-bold">Total Financial Resources:</span> {{ totalFinancialResources }}
        </div>
      </div>
      <div class="section-content-text">
        <app-edit-overlay [isPlaceholder]="!hasSelectedInitiative|| hasNoResources"
                          [isEditor]="!isEditItemDisabled"
                          (planCoordinateChange)="onPlanCoordinateChangeDesignImplementationPlan()">

          <div class="funding-sources break-text" *ngIf="!hasResourcesPlaceholder">
            <span class="semi-bold">Source of Funding:</span> {{ totalFundingSources }}
          </div>
          <div class="other-resources" *ngIf="!hasResourcesPlaceholder">
            <span class="semi-bold">Other</span>
          </div>
          <div>
            <div class="section-content-subcontainer">
                <table class="resource-list" *ngIf="!hasResourcesPlaceholder">
                  <tr *ngFor="let row of otherResources | tableCell: 2">
                    <ng-container *ngFor="let resource of row">
                      <td *ngIf="resource && resource.trim().length > 0" colspan="1">
                        <li class="break-text">{{ resource }}</li>
                      </td>
                    </ng-container>
                  </tr>
                </table>
                <div class="resource-list-placeholder" *ngIf="hasResourcesPlaceholder"></div>
            </div>
          </div>
        </app-edit-overlay>
      </div>
    </div>
    <div class="section-content">
      <div class="section-vbar" [style.background-color]="vbarDark20Color">
        <div class="section-vbar-diamond" [style.background-color]="vbarDark40Color"></div>
      </div>
      <div class="section-content-border-content">
          <h4 [style.border-bottom-width]="initiativeBorderHeight"
              [style.border-color]="vbarPrimaryColor"
              class="manual-subheader">{{ headings.initiativeHeading }}</h4>
        <app-edit-overlay [isPlaceholder]="!hasSelectedInitiative|| hasNoInitiative"
                          [isEditor]="!isEditItemDisabled"
                          class="allow-shrink min-30"
                          (planCoordinateChange)="onPlanCoordinateChangeCreatingObjectivesAndCriticalInitiatives()">
          <p class="ci-content min-30">{{initiative}}</p>
        </app-edit-overlay>
      </div>
    </div>

    <div class="section-content">
      <div class="section-vbar" [style.background-color]="vbarPrimaryColor">
        <div class="section-vbar-diamond" [style.background-color]="vbarDark20Color"></div>
      </div>
      <div class="section-content-subheader"><h4>{{ headings.keyMeasureHeading }}</h4></div>
      <div class="section-content-text">
        <div class="section-content-subcontainer">
          <app-edit-overlay [isPlaceholder]="!hasSelectedInitiative|| hasNoMeasures"
                            [isEditor]="!isEditItemDisabled"
                            (planCoordinateChange)="onPlanCoordinateChangeIdentifyOutcomesAndKeyMeasures()">
            <table class="resource-list" *ngIf="!hasKeyMeasuresPlaceholder">
              <tr *ngFor="let row of measures | tableCell: 2">
                <td *ngFor="let measure of row" colspan="1">
                  <li class="break-text">{{ measure }}</li>
                </td>
              </tr>
            </table>
            <div class="resource-list-placeholder" *ngIf="hasKeyMeasuresPlaceholder"></div>
          </app-edit-overlay>
        </div>
      </div>
      <div class="section-content-subheader"><h4>Intended Outcome(s)</h4></div>
      <div class="section-content-text">
        <div class="section-content-subcontainer">
          <app-edit-overlay [isPlaceholder]="!hasSelectedInitiative|| hasNoOutcomes"
                            [isEditor]="!isEditItemDisabled"
                            (planCoordinateChange)="onPlanCoordinateChangeIdentifyOutcomesAndKeyMeasures()">
            <table class="resource-list" *ngIf="!hasOutcomesPlaceholder">
              <tr *ngFor="let row of outcomes | tableCell: 2">
                <td *ngFor="let outcome of row" colspan="1">
                  <li class="break-text">{{ outcome }}</li>
                </td>
              </tr>
            </table>
            <div class="resource-list-placeholder" *ngIf="hasOutcomesPlaceholder"></div>
          </app-edit-overlay>
        </div>
      </div>
    </div>
    <div class="section-content">
      <div class="section-vbar" [style.background-color]="vbarLight20Color">
        <div class="section-vbar-diamond" [style.background-color]="vbarPrimaryColor"></div>
      </div>
      <div class="section-content-subheader"><h4>{{ headings.objectiveHeading }}</h4></div>
      <div class="section-content-text margin-bottom">
        <div class="section-content-subcontainer">
          <app-edit-overlay [isPlaceholder]="!hasSelectedInitiative|| hasNoObjective"
                            [isEditor]="!isEditItemDisabled"
                            (planCoordinateChange)="onPlanCoordinateChangeCreatingObjectivesAndCriticalInitiatives()">
            <p class="min-40">{{objective}}</p>
          </app-edit-overlay>
        </div>
      </div>
    </div>
    <!-- Vision -->
    <div class="section-content">
      <div class="section-vbar" [style.background-color]="vbarLight20Color">
      </div>
    </div>
    <div auto="vission-section-header" class="section-header">
      <div class="section-vbar rounded-bottom" [style.background-color]="vbarBaseColor">
        <div class="section-vbar-diamond" [style.background-color]="vbarLight20Color"></div>
      </div>
      <div class="section-header-content-wrapper bottom">
        <div class="section-header-text dark">
          <h4>Vision</h4>
        </div>
        <div class="section-content-text">
          <app-edit-overlay [isPlaceholder]="!hasSelectedInitiative|| hasNoVision"
                            [isEditor]="!isEditItemDisabled"
                            class="allow-shrink min-40"
                            (planCoordinateChange)="onPlanCoordinateChangePurposeMissionBeliefs()">
            <p class="min-40" [innerHTML]="visionDescription"></p>
          </app-edit-overlay>
        </div>
      </div>
    </div>

  </div>
  <button auto="back-to-eval-btn"
    class="btn btn-primary bte-button"
    (click)="onPlanCoordinateChangeEvaluating()">Back to Evaluating</button>
</section>
